import { useQuery } from "@tanstack/react-query";
import axios from "axios";

import { localStorageToken, authStorage } from "../utils/variables";

export const useStoreAdmins = (storeId, storeAdminsOptions) => {
  return useQuery({
    queryKey: ["storeAdmins", storeId, storeAdminsOptions],
    queryFn: async () => {
      const token = authStorage.getItem(localStorageToken);

      const { data } = await axios.get(
        `${process.env.REACT_APP_STORE_LOCATION_API}/stores/${storeId}/admins`,
        {
          params: storeAdminsOptions,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (data?.code === 200) return data.data;
    },
    enabled: !!storeId,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });
};

export const useStoreAdminDetails = (storeId, adminId) => {
  return useQuery({
    queryKey: ["storeAdminDetails", storeId, adminId],
    queryFn: async () => {
      const token = authStorage.getItem(localStorageToken);

      const { data } = await axios.get(
        `${process.env.REACT_APP_STORE_LOCATION_API}/stores/${storeId}/admins/${adminId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (data?.code === 200) return data.data;
    },
    enabled: !!storeId && !!adminId,
    refetchOnWindowFocus: false,
  });
};

export const useStoreAdminsMaster = () => {
  return useQuery({
    queryKey: ["storeAdminsMasterData"],
    queryFn: async () => {
      const { data } = await axios.get(
        `${process.env.REACT_APP_STORE_LOCATION_API}/store-admin-master`
      );

      if (data?.code === 200) return data.data;
    },
    refetchOnWindowFocus: false,
  });
};
